import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import swal from 'sweetalert';
import api from "../../../../../services/api";
import utils from "../../../../../utils/utils";
import "./style.css";


export default class TabelaPortfolio extends Component {

    constructor(props) {
        super(props);
        
        this.state = {
            aplicationName: "Módulo de Metas",
            metas: [],
            total: [],
            modalidade: "Todas",
        }
        
    }

    soma = (metas) => {
        let soma = Array(8).fill(0);
        metas && metas.forEach(meta => {
            soma[0] += meta.metaEmpresasAtendidas;
            soma[1] += meta.metaAtendimentos;
            soma[2] += meta.mediaHH;
            soma[3] += meta.totalHH;
            soma[4] += meta.totalEnsaiosCalibracoes;
            soma[5] += meta.totalLaudosRelatorios;
            soma[6] += meta.valorHora;
            soma[7] += meta.receitaPrevista;
        });
        soma = soma.map((valor, i) => {
            return [6, 7].includes(i) ? utils.formataValorMoeda(valor) : utils.formataValor(valor);
        });
        return soma;
    }

    render() {
        let { metas, unidade } = this.props;
        let soma = this.soma(metas).splice(0, 6);
        return (
            <Fragment>

                <div className="row pr-3 pl-3">
                    <div className="col-md-12 ml-auto mr-auto">
                        <div className="card card-user">
                            <div className="card-header">
                                <div className="row row-tabela">
                                    <div className="col-md-12">

                                        <table border="1" className="gap table table-striped table-bordered table-hover table-sm no-space-bottom table-responsive">
                                            <thead>
                                                <tr>
                                                    <th>Unidade</th>
                                                    <th>linha de Atuacao</th>
                                                    <th>CR</th>
                                                    <th>Categoria</th>
                                                    <th>Produto</th>
                                                    <th>Meta de Empresas Atendidas</th>
                                                    <th>Meta de Atendimento</th>
                                                    <th>Média de H.H por atendimento</th>
                                                    <th>H.H Total</th>
                                                    <th>Total Ensaios / Calibrações</th>
                                                    <th>Total Laudos / Relatórios</th>
                                                    {/* <th>Valor Hora/Serviço</th>
                                                    <th>Receita Prevista 2022</th> */}
                                                    <th>Ação</th>
                                                </tr>
                                            </thead>
                                            <tbody id="metasCursos">
                                                {(metas || []).map((meta, key) => {
                                                    return (
                                                        <tr key={`${meta._id}`}>
                                                            <td>{meta.Sigla}</td>
                                                            <td className="tooltipp text-dark">{meta.linhaAtuacao} <span className="tooltiptext">&#9673; {meta.cr}</span></td>
                                                            <td>{meta.cr}</td>
                                                            <td>{meta.categoria}</td>
                                                            <td>{meta.produtoNacional}</td>
                                                            <td>{utils.formataValor(meta.metaEmpresasAtendidas)}</td>
                                                            <td>{utils.formataValor(meta.metaAtendimentos)}</td>
                                                            <td>{utils.formataValor(meta.mediaHH)}</td>
                                                            <td>{utils.formataValor(meta.totalHH)}</td>
                                                            <td>{utils.formataValor(meta.totalEnsaiosCalibracoes)}</td>
                                                            <td>{utils.formataValor(meta.totalLaudosRelatorios)}</td>
                                                            {/* <td>{utils.formataValorMoeda(meta.valorHora)}</td>
                                                            <td>{utils.formataValorMoeda(meta.receitaPrevista)}</td> */}
                                                            <td>
                                                                <div className="block-acao">
                                                                    <span>
                                                                        <span className="btn btn-link btn-info edit" onClick={() => this.props.exibeFichaSweetAlert(meta._id)}>
                                                                            <i className="fa fa-tags"></i>
                                                                        </span>
                                                                    </span>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )
                                                })}

                                            </tbody>
                                            <tfoot>
                                                <tr className={"table-secondary total_curso"}>
                                                    <th scope="row">Total</th>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    {soma.map((valor, i) => {
                                                        return(
                                                            i !== 6 ? <td key={i}>{valor}</td> : <td key={i}></td>
                                                        )
                                                    })}
                                                    <td></td>
                                                </tr>
                                            </tfoot>
                                        </table>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </Fragment>
        )
    }
}